import React from 'react';
import { TartaWordmark } from './TartaWordmark';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-espresso text-cream/60 pt-24 pb-12 border-t border-cream/5" data-id="element-129" data-mp="32nulgo2wc31d">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14" data-id="element-130" data-mp="32m1awxp5wyo3">
        <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-10 pb-16 border-b border-cream/10" data-id="element-131" data-mp="36q953aee36tp">
          <div className="lg:col-span-5 text-cream" data-id="element-132" data-mp="3ufjvbxy45itl">
            <TartaWordmark height={26} data-id="element-133" data-mp="39922nzchmct" />
            <p className="mt-3 text-[10px] tracking-[0.4em] uppercase text-cream/50" data-id="element-134" data-mp="387ejk1577e7">
              {t.footer.tagline}
            </p>
            <p className="mt-10 font-serif italic text-cream/50 text-lg max-w-sm leading-[1.5]" data-id="element-135" data-mp="3qdf4f6z1v0an">
              {t.footer.quote}
            </p>
          </div>
          <div className="lg:col-span-3" data-id="element-136" data-mp="29xlymixf0ugg">
            <p className="text-[10px] tracking-[0.3em] uppercase text-caramel mb-5" data-id="element-137" data-mp="2eya1q2yx51r1">
              {t.footer.origin}
            </p>
            <p className="text-[14px]" data-id="element-138" data-mp="3l8qxu8j60rtk">{t.footer.originValue}</p>
            <p className="text-[14px] text-cream/40 mt-1" data-id="element-139" data-mp="3gah0br9yxf4s">
              {t.footer.originSub}
            </p>
          </div>
          <div className="lg:col-span-4" data-id="element-140" data-mp="3v7zxni0pp0nu">
            <p className="text-[10px] tracking-[0.3em] uppercase text-caramel mb-5" data-id="element-141" data-mp="3v91b1t579z8q">
              {t.footer.follow}
            </p>
            <a href="mailto:tarta@tartahtx.com" className="block text-[14px] hover:text-caramel transition-colors duration-500" data-id="element-142" data-mp="830grbvt3sxb">
              {t.footer.email}
            </a>
            <a href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" className="block mt-2 text-[14px] hover:text-caramel transition-colors duration-500" data-id="element-143" data-mp="htd0x2zplk2x">
              @tartahtx
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-6 sm:items-center sm:justify-between" data-id="element-144" data-mp="msppbs68az7m">
          <div className="flex flex-wrap gap-x-8 gap-y-2 text-[10px] tracking-[0.3em] uppercase text-cream/40" data-id="element-145" data-mp="tvw9ald1dni3">
            {t.footer.links.map(link => <a key={link} href="#" className="hover:text-caramel transition-colors duration-500" data-id="element-146" data-mp="yrv3wqoyk1qy">
                {link}
              </a>)}
          </div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-cream/30" data-id="element-147" data-mp="1cmdwybj0hswl">
            © 2025 {t.footer.copyright}
          </p>
        </div>

        <p className="mt-8 text-[10px] tracking-[0.3em] uppercase text-cream/25" data-id="element-148" data-mp="1hms65wwcn8w7">
          {t.footer.crafted}
        </p>
      </div>
    </footer>;
}